import React from 'react';
import { Box } from '@mui/material';
import { __t } from '../../../i18n/t';
import { Ask } from '../../../components/wizardKit/basics';
import { CheckRow, LabeledInput } from '../../../components/wizardKit/controls';
import { parseCurrency } from '../../../utils';

interface BudgetStepProps {
  maxTotalSpend: number | null;
  onChange: (maxTotalSpend: number | null) => void;
}

// Ritmo do cadastro em etapas (o mesmo do desconto v2): 28 px entre perguntas.
const containerSx = { display: 'flex', flexDirection: 'column', gap: 3.5, pt: 2.25, pb: 3.5, maxWidth: 968 };

/** Sem o "R$" na frente: ele é o prefixo do campo. */
const formatAmount = (value: number) =>
  value.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

const BudgetStep: React.FC<BudgetStepProps> = ({ maxTotalSpend, onChange }) => {
  const noBudget = maxTotalSpend === null;

  return (
    <Box sx={containerSx}>
      <Ask
        id="q-orcamento"
        title="Tem teto de gasto?"
        help={__t('Ao atingir, a campanha encerra antes do fim. O sistema confere a cada 15 minutos, então pode passar um pouco do teto entre uma checagem e outra.')}
      >
        <CheckRow checked={noBudget} onChange={() => onChange(noBudget ? 0 : null)}>
          Sem teto de gasto
        </CheckRow>
        {!noBudget && (
          <LabeledInput
            id="orcamento-maximo"
            label="Gasto máximo total"
            prefix="R$"
            inputMode="decimal"
            width={200}
            value={formatAmount(maxTotalSpend || 0)}
            onChange={(e) => onChange(parseCurrency(e.target.value))}
          />
        )}
      </Ask>
    </Box>
  );
};

export default BudgetStep;
